var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.187 15.151h9.126a1.52 1.52 0 001.52-1.508V1.575a1.52 1.52 0 00-1.52-1.509H2.187a1.52 1.52 0 00-1.52 1.509v12.068c0 .83.684 1.508 1.52 1.508zm0 12.068h9.126a1.52 1.52 0 001.52-1.508v-6.034a1.52 1.52 0 00-1.52-1.509H2.187a1.52 1.52 0 00-1.52 1.509v6.034c0 .83.684 1.508 1.52 1.508zm15.209 0h9.125a1.52 1.52 0 001.52-1.508V13.643a1.52 1.52 0 00-1.52-1.509h-9.125a1.52 1.52 0 00-1.521 1.509V25.71c0 .83.684 1.508 1.52 1.508zM15.875 1.575v6.034c0 .83.684 1.508 1.52 1.508h9.126a1.52 1.52 0 001.52-1.508V1.575a1.52 1.52 0 00-1.52-1.509h-9.125a1.52 1.52 0 00-1.521 1.509z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconWhite);
export default __webpack_public_path__ + "static/media/dashboard-icon-white.dc975991ababd24425e8ba25561b5484.svg";
export { ForwardRef as ReactComponent };